import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import ApiService from "./services/api";
import {TokenService} from "./services/token";
import UserService from "./services/user";

ApiService.init(process.env.VUE_APP_ROOT_API);
if(TokenService.getToken()){
  ApiService.setHeader();
  ApiService.mount401Interceptor();
}
else{
  UserService.getToken();
}


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
